




































































































































































































































































































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import {
  GET_REGISTER_USER_FORM_VISIBILITY,
  UPDATE_REGISTER_USER_FORM_VISIBILITY,
  GET_SELECTED_USER,
  UPDATE_SELECTED_USER,
  FETCH_USER_LIST,
  CREATE_USER_LIST,
  CREATE_NEW_USER,
  UPDATE_USER_LIST,
  UPDATE_USER,
  GET_CURRENT_USER_TAB,
  UPDATE_CURRENT_USER_TAB,
  GET_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  UPDATE_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  UPDATE_USER_FUNCTIONALITY_RESTRICTIONS,
  FETCH_USER_FUNCTIONALITY_RESTRICTIONS,
  GET_CLIENT_CONTRACTS,
  FETCH_USER_BONDS_LIST,
  UPDATE_USER_BONDS,
  GET_USER_BONDS,
  FETCH_LOCALE_TYPES_LIST,
  UPDATE_EMAIL_CONFIRMATION,
  FETCH_EMAIL_CONFIRMATION, FETCH_ROLE_CLASSIFICATIONS, GET_ROLE_CLASSIFICATIONS,
} from '@/modules/user/store';

import {
  FETCH_PROFILE_LIST,
  CREATE_PROFILE_LIST,
  GET_PROFILE_LIST,
  GET_COUNTRY_LIST,
  GET_FLAG_LIST,
  GET_VEHICLE_TYPE_LIST,
  FETCH_FLAG_LIST,
  FETCH_VEHICLE_TYPE_LIST,
  FETCH_COUNTRY_LIST,
} from '@/modules/profile/store';

import { GET_USER_TYPE_LIST } from '@/modules/user-type/store';

import { MessageService } from '@/services/messageService';
import { IProfile } from '@/modules/profile/models';
import { IUser, userTabs } from '@/modules/user/models';
import { IUserType } from '@/modules/user-type/models';
import { IBond } from '@/models/Bond';
import { IFlag, IVehicleType, ICountry } from '../../../../models';
import moment from 'moment';
import {IRoleClassification} from '@/models/IRoleClassification';

@Component({
  filters: {
    formatDate(value: any) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm');
      }
    },
  },
})
export default class extends Vue {
  public saving: boolean = false;
  public valid: boolean = false;
  public showPassword: boolean = false;
  public newUser: IUser = {
    id: 0,
    cdclicon: 0,
    idcountry: 0,
    idflag: 0,
    idvehicletype: 0,
    idroleclassification: 0,
    confirmationdateemail: undefined,
    isactive: true,
    dateofinclusion: undefined,
    email: '',
    fullusername: '',
    shortname: '',
    idusertype: 0,
    isemailconfirmed: false,
    office: '',
    password: '',
    phonenumber: '',
    functionalityrestrictions: [],
    profiles: [],
    bonds: [],
    usertype: { isactive: true, id: 0, usertypename: '' },
  };

  public search: string = '';
  public dialog: boolean = false;
  public mask: string = '(##) #####-####';
  public bondOptions: any = [
    {
      title: 'Configurar Vínculo por Loja/Grupo',
      icon: 'store_mall_directory',
    },
    { title: 'Configurar Vínculo por Área de Atuação', icon: 'map' },
  ];

  public defaultRules: any[] = [(v: any) => !!v || 'Campo obrigatório.'];

  public passwordRules: any[] = [
    (v: any) => {
      const upperCasePattern = /[A-Z]/;
      const lowerCasePattern = /[a-z]/;
      const numberPattern = /[0-9]/;
      const specialCharacterPattner = /[^0-9A-Za-z]/;

      return (
        (upperCasePattern.test(v) &&
          lowerCasePattern.test(v) &&
          numberPattern.test(v) &&
          specialCharacterPattner.test(v)) ||
        'A senha deve conter ao menos 1 letra maiúscula, 1 minúscula, 1 caracter especial e 1 número.'
      );
    },
    (v: any) => !!v || 'A senha é obrigatória',
    (v: any) =>
      (v && v.length > 5) || 'A senha precisa ter pelo menos 6 caracteres.',
  ];

  public emailRules: any[] = [
    (v: any) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(v) || 'E-mail inválido.';
    },
    (v: any) => !!v || 'E-mail é obrigatório',
    (v: any) =>
      (v && v.length <= 256) || 'E-mail precisa ter menos que 256 caracteres.',
  ];

  @Getter(GET_SELECTED_USER)
  public userSelected: IUser;

  @Getter(GET_REGISTER_USER_FORM_VISIBILITY)
  public showUserForm: boolean;

  @Getter(GET_PROFILE_LIST)
  public profiles: IProfile[];

  @Getter(GET_FLAG_LIST)
  public flags: IFlag[];

  @Getter(GET_VEHICLE_TYPE_LIST)
  public vehicleTypes: IVehicleType[];

  @Getter(GET_COUNTRY_LIST)
  public countries: ICountry[];

  @Getter(GET_USER_TYPE_LIST)
  public userTypes: IUserType[];

  @Getter(GET_USER_PROFILE_FUNCTIONALITIES_GROUPED)
  public profileFunctionalities: any[];

  @Getter(GET_CLIENT_CONTRACTS)
  public clientContracts: any[];

  @Getter(GET_USER_BONDS)
  public userBonds: IBond[];

  @Getter(GET_ROLE_CLASSIFICATIONS)
  public roleClassifications: IRoleClassification[];

  @Action(CREATE_NEW_USER)
  public createUser: any;

  @Action(UPDATE_USER_LIST)
  public updateUsers: any;

  @Action(FETCH_USER_LIST)
  public getAllUsers: any;

  @Action(CREATE_USER_LIST)
  public setAllUsers: any;

  @Action(UPDATE_SELECTED_USER)
  private setSelectedUser: any;

  @Action(UPDATE_USER)
  private updateUser: any;

  @Action(FETCH_PROFILE_LIST)
  private getAllFProfiles: any;

  @Action(FETCH_FLAG_LIST)
  private getAllFlags: any;

  @Action(FETCH_COUNTRY_LIST)
  private getAllCountries: any;

  @Action(FETCH_VEHICLE_TYPE_LIST)
  private getAllVehicleTypes: any;

  @Action(CREATE_PROFILE_LIST)
  private setAllProfiles: any;

  @Action(UPDATE_CURRENT_USER_TAB)
  private setCurrentTab: any;

  @Action(FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED)
  private getProfileFunctionalitiesGrouped: any;

  @Action(UPDATE_USER_PROFILE_FUNCTIONALITIES_GROUPED)
  private setProfileFunctionalitiesGrouped: any;

  @Action(UPDATE_USER_FUNCTIONALITY_RESTRICTIONS)
  private setUserFunctionalityRestrictions: any;

  @Action(FETCH_USER_FUNCTIONALITY_RESTRICTIONS)
  private getUserFunctionalityRestrictions: any;

  @Action(UPDATE_USER_BONDS)
  private setUserBonds: any;

  @Action(FETCH_LOCALE_TYPES_LIST)
  private getLocaleTypesList: any;

  @Action(FETCH_EMAIL_CONFIRMATION)
  private confirmEmailAction: any;

  @Action(UPDATE_EMAIL_CONFIRMATION)
  private updateEmail: any;

  @Action(FETCH_ROLE_CLASSIFICATIONS)
  private getRoleClassifications: any;

  public cancelEdit() {
    this.setSelectedUser(this.newUser);
    this.setUserBonds([]);
    this.setProfileFunctionalitiesGrouped([]);

    this.getAllUsers(true).then((ret: any) => {
      this.setAllUsers(ret.data);
      this.setCurrentTab(userTabs.tabs.listtab);
    });
  }

  public saveUser() {
    if (!this.userSelected.id || this.userSelected.id === 0) {
      this.addUser();
    } else {
      this.update();
    }
  }

  public created() {
    this.getAllFlags();
    this.getAllCountries();
    this.getAllVehicleTypes();
    this.getRoleClassifications();

    this.getAllFProfiles().then((ret: any) => {
      this.setAllProfiles(ret.data);
    });
  }

  public confirmEmail() {
    this.confirmEmailAction(this.userSelected.id).then((ret: any) => {
      MessageService.Success('Sucesso', 'E-mail confirmado com sucesso.');
      this.cancelEdit();
    });
  }

  private async getLocaleTypes() {
    await this.getLocaleTypesList(this.userSelected.cdclicon);
  }

  private addUser() {
    this.saving = true;

    // Get User Bonds to Save
    this.userSelected.bonds = this.userBonds;

    this.createUser(this.userSelected)
      .then((ret: any) => {
        MessageService.Success('Sucesso', 'Operação realizada com sucesso.');
        this.cancelEdit();
      })
      .finally(() => (this.saving = false));
  }

  private update() {
    this.saving = true;
    this.updateUser(this.userSelected)
      .then(() => {
        this.resetParameters();
      })
      .finally(() => (this.saving = false));
  }

  private resetParameters() {
    MessageService.Success('Sucesso', 'Operação realizada com sucesso.');

    this.setSelectedUser(this.newUser);
    this.setProfileFunctionalitiesGrouped([]);
    this.setCurrentTab(userTabs.tabs.listtab);
  }

  private getProfileFunctionalities() {
    const ids =
      this.userSelected &&
      this.userSelected.profiles &&
      this.userSelected.profiles.length > 0
        ? this.userSelected.profiles.join(',')
        : '0';

    if (ids !== '0') {
      this.getProfileFunctionalitiesGrouped(ids).then((retg: any) => {
        this.setProfileFunctionalitiesGrouped(retg.data);

        this.getUserFunctionalityRestrictions(this.userSelected.id).then(
          (ret: any) => {
            this.setUserFunctionalityRestrictions(ret.data);
          },
        );
      });
    }
  }
}
